import { Box } from '@mui/system';
import OvLoadingIndicator from './ovLoadingIndicator';

const LoadingBox = (): JSX.Element => (
  <Box sx={{ margin: '100px' }}><OvLoadingIndicator /></Box>
);

export default LoadingBox;
